/**
 * @param {number} total should be greater than 0
 * @param {number} quantity
 * @param {number} precision How many numbers will appear after the floating point
 * @return {number} The float representation of the percentage
 * calculation result
 */
export const calculatePercentage = (total, quantity, precision = 0) => {
  if ([total, quantity, precision].some((n) => typeof n !== "number")) {
    throw new Error(
      "All the params must be of type number to " + "calculate the percentage."
    )
  }

  const percentage =
    total > 0 ? parseFloat(((quantity * 100) / total).toFixed(precision)) : 0
  return percentage > 100 ? 100 : percentage
}
